import { render, staticRenderFns } from "./BC_categoryInfo.vue?vue&type=template&id=e8d32d8c&"
import script from "./BC_categoryInfo.vue?vue&type=script&lang=js&"
export * from "./BC_categoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./BC_categoryInfo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports